(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

var _validForm = require('./src/valid-form');

var _validForm2 = _interopRequireDefault(_validForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.ValidForm = _validForm2.default;
window.ValidForm.toggleInvalidClass = _validForm.toggleInvalidClass;
window.ValidForm.handleCustomMessages = _validForm.handleCustomMessages;
window.ValidForm.handleCustomMessageDisplay = _validForm.handleCustomMessageDisplay;

},{"./src/valid-form":3}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clone = clone;
exports.defaults = defaults;
exports.insertAfter = insertAfter;
exports.insertBefore = insertBefore;
exports.forEach = forEach;
exports.debounce = debounce;
function clone(obj) {
  var copy = {};
  for (var attr in obj) {
    if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr];
  }
  return copy;
}

function defaults(obj, defaultObject) {
  obj = clone(obj || {});
  for (var k in defaultObject) {
    if (obj[k] === undefined) obj[k] = defaultObject[k];
  }
  return obj;
}

function insertAfter(refNode, nodeToInsert) {
  var sibling = refNode.nextSibling;
  if (sibling) {
    var _parent = refNode.parentNode;
    _parent.insertBefore(nodeToInsert, sibling);
  } else {
    parent.appendChild(nodeToInsert);
  }
}

function insertBefore(refNode, nodeToInsert) {
  var parent = refNode.parentNode;
  parent.insertBefore(nodeToInsert, refNode);
}

function forEach(items, fn) {
  if (!items) return;
  if (items.forEach) {
    items.forEach(fn);
  } else {
    for (var i = 0; i < items.length; i++) {
      fn(items[i], i, items);
    }
  }
}

function debounce(ms, fn) {
  var timeout = void 0;
  var debouncedFn = function debouncedFn() {
    clearTimeout(timeout);
    timeout = setTimeout(fn, ms);
  };
  return debouncedFn;
}

},{}],3:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleInvalidClass = toggleInvalidClass;
exports.handleCustomMessages = handleCustomMessages;
exports.handleCustomMessageDisplay = handleCustomMessageDisplay;
exports.default = validForm;

var _util = require('./util');

// toggleInvalidClass

function toggleInvalidClass(input, invalidClass) {
  input.addEventListener('invalid', function () {
    input.classList.add(invalidClass);
  });

  input.addEventListener('input', function () {
    if (input.validity.valid) {
      input.classList.remove(invalidClass);
    }
  });
}

// handleCustomMessages

var errorProps = ['badInput', 'patternMismatch', 'rangeOverflow', 'rangeUnderflow', 'stepMismatch', 'tooLong', 'tooShort', 'typeMismatch', 'valueMissing', 'customError'];

function getCustomMessage(input, customMessages) {
  customMessages = customMessages || {};
  var localErrorProps = [input.type + 'Mismatch'].concat(errorProps);
  var validity = input.validity;

  for (var i = 0; i < localErrorProps.length; i++) {
    var prop = localErrorProps[i];
    if (validity[prop]) {
      return input.getAttribute('data-' + prop) || customMessages[prop];
    }
  }
}

function handleCustomMessages(input, customMessages) {
  function checkValidity() {
    var message = input.validity.valid ? null : getCustomMessage(input, customMessages);
    input.setCustomValidity(message || '');
  }
  input.addEventListener('input', checkValidity);
  input.addEventListener('invalid', checkValidity);
}

// handleCustomMessageDisplay

function handleCustomMessageDisplay(input, options) {
  var validationErrorClass = options.validationErrorClass,
      validationErrorParentClass = options.validationErrorParentClass,
      errorPlacement = options.errorPlacement;


  function checkValidity(options) {
    var insertError = options.insertError;

    var parentNode = input.parentNode;
    var errorNode = parentNode.querySelector('.' + validationErrorClass) || document.createElement('div');

    if (!input.validity.valid && input.validationMessage) {
      errorNode.className = validationErrorClass;
      errorNode.textContent = input.validationMessage;

      if (insertError) {
        errorPlacement === 'before' ? (0, _util.insertBefore)(input, errorNode) : (0, _util.insertAfter)(input, errorNode);
        parentNode.classList.add(validationErrorParentClass);
      }
    } else {
      parentNode.classList.remove(validationErrorParentClass);
      errorNode.remove();
    }
  }
  input.addEventListener('input', function () {
    // We can only update the error or hide it on input.
    // Otherwise it will show when typing.
    checkValidity({ insertError: false });
  });
  input.addEventListener('invalid', function (e) {
    e.preventDefault();
    // We can also create the error in invalid.
    checkValidity({ insertError: true });
  });
}

var defaultOptions = {
  invalidClass: 'invalid',
  validationErrorClass: 'validation-error',
  validationErrorParentClass: 'has-validation-error',
  customMessages: {},
  errorPlacement: 'before'

  // validForm

};function validForm(element, options) {
  if (!element || !element.nodeName) {
    throw new Error('First arg to validForm must be a form, input, select, or textarea');
  }

  var inputs = void 0;
  var type = element.nodeName.toLowerCase();

  options = (0, _util.defaults)(options, defaultOptions);
  if (type === 'form') {
    inputs = element.querySelectorAll('input, select, textarea');
    focusInvalidInput(element, inputs);
  } else if (type === 'input' || type === 'select' || type === 'textarea') {
    inputs = [element];
  } else {
    throw new Error('Only form, input, select, or textarea elements are supported');
  }

  validFormInputs(inputs, options);
}

function focusInvalidInput(form, inputs) {
  var focusFirst = (0, _util.debounce)(100, function () {
    var invalidNode = form.querySelector(':invalid');
    if (invalidNode) invalidNode.focus();
  });
  (0, _util.forEach)(inputs, function (input) {
    return input.addEventListener('invalid', focusFirst);
  });
}

function validFormInputs(inputs, options) {
  var invalidClass = options.invalidClass,
      customMessages = options.customMessages;

  (0, _util.forEach)(inputs, function (input) {
    toggleInvalidClass(input, invalidClass);
    handleCustomMessages(input, customMessages);
    handleCustomMessageDisplay(input, options);
  });
}

},{"./util":2}]},{},[1]);

/**
 *
 *
 * @author Jerry Bendy <jerry@icewingcc.com>
 * @licence MIT
 *
 */

(function(self) {
    'use strict';

    var nativeURLSearchParams = (self.URLSearchParams && self.URLSearchParams.prototype.get) ? self.URLSearchParams : null,
        isSupportObjectConstructor = nativeURLSearchParams && (new nativeURLSearchParams({a: 1})).toString() === 'a=1',
        // There is a bug in safari 10.1 (and earlier) that incorrectly decodes `%2B` as an empty space and not a plus.
        decodesPlusesCorrectly = nativeURLSearchParams && (new nativeURLSearchParams('s=%2B').get('s') === '+'),
        __URLSearchParams__ = "__URLSearchParams__",
        // Fix bug in Edge which cannot encode ' &' correctly
        encodesAmpersandsCorrectly = nativeURLSearchParams ? (function() {
            var ampersandTest = new nativeURLSearchParams();
            ampersandTest.append('s', ' &');
            return ampersandTest.toString() === 's=+%26';
        })() : true,
        prototype = URLSearchParamsPolyfill.prototype,
        iterable = !!(self.Symbol && self.Symbol.iterator);

    if (nativeURLSearchParams && isSupportObjectConstructor && decodesPlusesCorrectly && encodesAmpersandsCorrectly) {
        return;
    }


    /**
     * Make a URLSearchParams instance
     *
     * @param {object|string|URLSearchParams} search
     * @constructor
     */
    function URLSearchParamsPolyfill(search) {
        search = search || "";

        // support construct object with another URLSearchParams instance
        if (search instanceof URLSearchParams || search instanceof URLSearchParamsPolyfill) {
            search = search.toString();
        }
        this [__URLSearchParams__] = parseToDict(search);
    }


    /**
     * Appends a specified key/value pair as a new search parameter.
     *
     * @param {string} name
     * @param {string} value
     */
    prototype.append = function(name, value) {
        appendTo(this [__URLSearchParams__], name, value);
    };

    /**
     * Deletes the given search parameter, and its associated value,
     * from the list of all search parameters.
     *
     * @param {string} name
     */
    prototype['delete'] = function(name) {
        delete this [__URLSearchParams__] [name];
    };

    /**
     * Returns the first value associated to the given search parameter.
     *
     * @param {string} name
     * @returns {string|null}
     */
    prototype.get = function(name) {
        var dict = this [__URLSearchParams__];
        return this.has(name) ? dict[name][0] : null;
    };

    /**
     * Returns all the values association with a given search parameter.
     *
     * @param {string} name
     * @returns {Array}
     */
    prototype.getAll = function(name) {
        var dict = this [__URLSearchParams__];
        return this.has(name) ? dict [name].slice(0) : [];
    };

    /**
     * Returns a Boolean indicating if such a search parameter exists.
     *
     * @param {string} name
     * @returns {boolean}
     */
    prototype.has = function(name) {
        return hasOwnProperty(this [__URLSearchParams__], name);
    };

    /**
     * Sets the value associated to a given search parameter to
     * the given value. If there were several values, delete the
     * others.
     *
     * @param {string} name
     * @param {string} value
     */
    prototype.set = function set(name, value) {
        this [__URLSearchParams__][name] = ['' + value];
    };

    /**
     * Returns a string containg a query string suitable for use in a URL.
     *
     * @returns {string}
     */
    prototype.toString = function() {
        var dict = this[__URLSearchParams__], query = [], i, key, name, value;
        for (key in dict) {
            name = encode(key);
            for (i = 0, value = dict[key]; i < value.length; i++) {
                query.push(name + '=' + encode(value[i]));
            }
        }
        return query.join('&');
    };

    // There is a bug in Safari 10.1 and `Proxy`ing it is not enough.
    var forSureUsePolyfill = !decodesPlusesCorrectly;
    var useProxy = (!forSureUsePolyfill && nativeURLSearchParams && !isSupportObjectConstructor && self.Proxy);
    /*
     * Apply polifill to global object and append other prototype into it
     */
    Object.defineProperty(self, 'URLSearchParams', {
        value: (useProxy ?
            // Safari 10.0 doesn't support Proxy, so it won't extend URLSearchParams on safari 10.0
            new Proxy(nativeURLSearchParams, {
                construct: function(target, args) {
                    return new target((new URLSearchParamsPolyfill(args[0]).toString()));
                }
            }) :
            URLSearchParamsPolyfill)
    });

    var USPProto = self.URLSearchParams.prototype;

    USPProto.polyfill = true;

    /**
     *
     * @param {function} callback
     * @param {object} thisArg
     */
    USPProto.forEach = USPProto.forEach || function(callback, thisArg) {
        var dict = parseToDict(this.toString());
        Object.getOwnPropertyNames(dict).forEach(function(name) {
            dict[name].forEach(function(value) {
                callback.call(thisArg, value, name, this);
            }, this);
        }, this);
    };

    /**
     * Sort all name-value pairs
     */
    USPProto.sort = USPProto.sort || function() {
        var dict = parseToDict(this.toString()), keys = [], k, i, j;
        for (k in dict) {
            keys.push(k);
        }
        keys.sort();

        for (i = 0; i < keys.length; i++) {
            this['delete'](keys[i]);
        }
        for (i = 0; i < keys.length; i++) {
            var key = keys[i], values = dict[key];
            for (j = 0; j < values.length; j++) {
                this.append(key, values[j]);
            }
        }
    };

    /**
     * Returns an iterator allowing to go through all keys of
     * the key/value pairs contained in this object.
     *
     * @returns {function}
     */
    USPProto.keys = USPProto.keys || function() {
        var items = [];
        this.forEach(function(item, name) {
            items.push(name);
        });
        return makeIterator(items);
    };

    /**
     * Returns an iterator allowing to go through all values of
     * the key/value pairs contained in this object.
     *
     * @returns {function}
     */
    USPProto.values = USPProto.values || function() {
        var items = [];
        this.forEach(function(item) {
            items.push(item);
        });
        return makeIterator(items);
    };

    /**
     * Returns an iterator allowing to go through all key/value
     * pairs contained in this object.
     *
     * @returns {function}
     */
    USPProto.entries = USPProto.entries || function() {
        var items = [];
        this.forEach(function(item, name) {
            items.push([name, item]);
        });
        return makeIterator(items);
    };


    if (iterable) {
        USPProto[self.Symbol.iterator] = USPProto[self.Symbol.iterator] || USPProto.entries;
    }


    function encode(str) {
        var replace = {
            '!': '%21',
            "'": '%27',
            '(': '%28',
            ')': '%29',
            '~': '%7E',
            '%20': '+',
            '%00': '\x00'
        };
        return encodeURIComponent(str).replace(/[!'\(\)~]|%20|%00/g, function(match) {
            return replace[match];
        });
    }

    function decode(str) {
        return str
            .replace(/[ +]/g, '%20')
            .replace(/(%[a-f0-9]{2})+/ig, function(match) {
                return decodeURIComponent(match);
            });
    }

    function makeIterator(arr) {
        var iterator = {
            next: function() {
                var value = arr.shift();
                return {done: value === undefined, value: value};
            }
        };

        if (iterable) {
            iterator[self.Symbol.iterator] = function() {
                return iterator;
            };
        }

        return iterator;
    }

    function parseToDict(search) {
        var dict = {};

        if (typeof search === "object") {
            // if `search` is an array, treat it as a sequence
            if (isArray(search)) {
                for (var i = 0; i < search.length; i++) {
                    var item = search[i];
                    if (isArray(item) && item.length === 2) {
                        appendTo(dict, item[0], item[1]);
                    } else {
                        throw new TypeError("Failed to construct 'URLSearchParams': Sequence initializer must only contain pair elements");
                    }
                }

            } else {
                for (var key in search) {
                    if (search.hasOwnProperty(key)) {
                        appendTo(dict, key, search[key]);
                    }
                }
            }

        } else {
            // remove first '?'
            if (search.indexOf("?") === 0) {
                search = search.slice(1);
            }

            var pairs = search.split("&");
            for (var j = 0; j < pairs.length; j++) {
                var value = pairs [j],
                    index = value.indexOf('=');

                if (-1 < index) {
                    appendTo(dict, decode(value.slice(0, index)), decode(value.slice(index + 1)));

                } else {
                    if (value) {
                        appendTo(dict, decode(value), '');
                    }
                }
            }
        }

        return dict;
    }

    function appendTo(dict, name, value) {
        var val = typeof value === 'string' ? value : (
            value !== null && value !== undefined && typeof value.toString === 'function' ? value.toString() : JSON.stringify(value)
        );

        // #47 Prevent using `hasOwnProperty` as a property name
        if (hasOwnProperty(dict, name)) {
            dict[name].push(val);
        } else {
            dict[name] = [val];
        }
    }

    function isArray(val) {
        return !!val && '[object Array]' === Object.prototype.toString.call(val);
    }

    function hasOwnProperty(obj, prop) {
        return Object.prototype.hasOwnProperty.call(obj, prop);
    }

})(typeof global !== 'undefined' ? global : (typeof window !== 'undefined' ? window : this));
var computedTracker = [];

// We will need to copy subscriptions here during writes, so that subscriptions can edit their original subscription lists
// safely. This is necessary for subscriptions that remove themselves.
var effects = [];

function trkl(initValue) {
    var value = initValue;
    var subscribers = [];

    var self = function (writeValue) {
        if (arguments.length) {
            write(writeValue);
        } else {
            return read();
        }
    };

    // Using string keys tells Uglify that we intend to export these symbols
    self['subscribe'] = subscribe;

    // declaring as a private function means the minifier can scrub its name on internal references
    function subscribe(subscriber, immediate) {
        if (!~subscribers.indexOf(subscriber)) {
            subscribers.push(subscriber);
        }
        if (immediate) {
            subscriber(value);
        }
    }

    self['unsubscribe'] = function (subscriber) {
        remove(subscribers, subscriber);
    };

    function write (newValue) {
        var oldValue = value;

        if (newValue === oldValue && (newValue === null || typeof newValue !== 'object')) {
            return; // bail out
        }

        value = newValue;
        effects.push.apply(effects, subscribers);

        // We will now rewind through as many effects as we have subscribers
        // We don't recheck the length during the loop, as subscribers may be mutated
        // (e.g. when a subscribers unsubs itself)
        var subCount = subscribers.length;
        for (var i = 0; i < subCount; i++) {
            // If a sub throws an error, the effects array will just keep growing and growing.
            // It won't stop operating properly, but it might eat memory. We're okay with this, I guess?
            effects.pop()(value, oldValue);
        }
    }

    function read () {
        var runningComputation = computedTracker[computedTracker.length - 1];
        if (runningComputation) {
            subscribe(runningComputation._subscriber);
        }
        return value;
    }

    return self;
}

trkl['computed'] = function (fn) {
    var self = trkl();
    var computationToken = {
        _subscriber : runComputed
    };

    runComputed();
    return self;

    function runComputed() {
        detectCircularity(computationToken);
        computedTracker.push(computationToken);
        var errors, result;
        try {
            result = fn();
        } catch (e) {
            errors = e;
        }
        computedTracker.pop();
        if (errors) {
            throw errors;
        }
        self(result);
    }
};

trkl['from'] = function (executor) {
    var self = trkl();
    executor(self);
    return self;
};

function detectCircularity(token) {
    if (computedTracker.indexOf(token) !== -1) {
        throw Error('Circular computation detected');
    }
}

function remove(array, item) {
    var position = array.indexOf(item);
    if (position !== -1) {
        array.splice(position, 1);
    }
}

if (typeof module === 'object') {
    module.exports = trkl;
} else {
    window['trkl'] = trkl;
}
/*
trkl.js is used for a minimal, but useful reactive library.
This is compiled in with the tessitura scripts only.
https: //github.com/jbreckmckye/trkl

See https://gist.github.com/austinhyde/4321f22a476e1cbee65f for detail
on the bindValue function, which is a helper for binding a 'standard'
Observable to the value of an HTML input. bindSingleChoice is a specialisation
designed for radiobuttons.
*/
/** This allows us to dispatch browser events in old IE and newer browsers */
SendBrowserAgnosticEvent = function(elem, eventName) {
    //Needed for IE Support: https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/dispatchEvent#Browser_Compatibility
    //https://stackoverflow.com/a/49071358/79677
    var event;
    if (typeof(Event) === 'function') {
        event = new Event(eventName);
    } else {
        event = document.createEvent('Event');
        event.initEvent(eventName, true, true);
    }
    elem.dispatchEvent(event);

    return event;
};

/** Get URL path for use in page detection */
function getUrlPath() {
    return window.location.toString().replace(new RegExp('^' + window.base_url), '')
}

/**
 * Show/hide password on the login form
 */
document.addEventListener('DOMContentLoaded', function() {
    // TO SHOW/HIDE PASSWORD ON LOGIN
    var _show = document.getElementById("showPw");


    if (_show != null) {
        _show.addEventListener('click', function (event) {
            var pw = document.getElementById("pw");
            if (pw.type === "password") {
                pw.type = "text";
            } else {
                pw.type = "password";
            }

        }, false);
    }
})

document.addEventListener('DOMContentLoaded', function (e) {
    /**
     * Set up any stepper inputs (numbers with up/down buttons)
     *
     * Note that stepUp and stepDown don't automatically fire events, so we trigger an 'input' event
     * each time we call them. This allows the observable bindings to update whenever needed without
     * extra intervention.
     */
    Array.from(document.querySelectorAll('.form-counter input[type="number"]')).forEach(function (item) {
        var dbtn = document.createElement('button');
        dbtn.setAttribute("id", "minus");
        dbtn.innerHTML = '-';
        dbtn.type = 'button';
        dbtn.addEventListener('click', function () {
            if (item.value > 1) {
                item.value = parseInt(item.value, 10) - 1;
            }
            SendBrowserAgnosticEvent(item, 'input')
        })
        item.parentNode.prepend(dbtn)
        var ubtn = document.createElement('button');
        ubtn.setAttribute("id", "plus");
        ubtn.innerHTML = '+';
        ubtn.type = 'button';
        ubtn.addEventListener('click', function () {
            if (!item.value) {
                item.value = 1
            } else {
                item.value = parseInt(item.value, 10) + 1
            }
            SendBrowserAgnosticEvent(item, 'input')
        })
        item.parentNode.append(ubtn);
    })
})

/**
 * Set up subscribers' additional tickets form
 */
document.addEventListener('DOMContentLoaded', function (e) {

    if (document.querySelectorAll('.form-counter input[type="number"]').length > 0) {
        setupSubsAdditional()
    }

    // HELP & FEEDBACK MODAL

    var _help = document.getElementById('help_info');
    var _feedback = document.getElementById('feedback_info');
    var _closeH = document.querySelector('.help_content .close');
    var _closeFB = document.querySelector('.feedback_content .close');
    if (_help != null) {
        _help.addEventListener("click", function () {
            var _index = this.getAttribute('data-modal');
            document.getElementById(_index).classList.add('active');
        });
    }
    if (_closeH != null) {
        _closeH.addEventListener("click", function () {
            var _index = this.getAttribute('data-index');
            document.getElementById(_index).classList.remove('active');
        });
    }

    if (_feedback != null) {
        _feedback.addEventListener("click", function () {
            var _index = this.getAttribute('data-modal');
            document.getElementById(_index).classList.add('active');
        });
    }
    if (_closeFB != null) {
        _closeFB.addEventListener("click", function () {
            var _index = this.getAttribute('data-index');
            document.getElementById(_index).classList.remove('active');
        });
    }

    // ADD CUSTOMER NUMBER TO FEEDBACK FORM

    var accountNumber__ = document.getElementById('accountNumber__');
    var _hiddenField = document.getElementById('fld_8227571_1');
    // console.log(_hiddenField)
    if(_hiddenField != null){
        _hiddenField.value = accountNumber__ ? accountNumber__.innerHTML : 'Not logged in';

        console.log(_hiddenField.value);
    }



    // ACCESSIBILITY DROPDOWN

    var _access = document.querySelectorAll("._accessibilityCheck input[type='radio']");
    if (_access != null) {
        for (var i = 0; i < _access.length; i++) {
            _access[i].addEventListener('change', function () {
                if (this.value == 1) {
                    document.getElementById("subscribe-accessibility-details").classList.add('active');
                } else {
                    document.getElementById("subscribe-accessibility-details").classList.remove('active');

                }
            });
        }
    }

    // TO OPEN AND CLOSE MY ACCOUNT MENU - QUICK LINKS

    var _burger = document.getElementById("burger");
    var _quick = document.getElementById("quickLinks");
    var _nav = document.getElementById("my-account-subnav");

    if (_burger != null) {
        _burger.addEventListener('click', function (event) {
            this.classList.toggle("active");
            // toggleClass(_quick, _h);
            _nav.classList.toggle('active');
            _quick.classList.toggle('active');
        }, false);
    }

    // TESSITURA FORM VALIDATION


    var _text = document.querySelectorAll("._forms input[type=text]");
    var _email = document.querySelectorAll("._forms input[type=email]");
    var _tel = document.querySelectorAll("._forms input[type=tel]");
    var _select = document.querySelectorAll("._forms select");
    var _exp = document.getElementById('editdetails_expiration');
    var _nameCard = document.getElementById('editdetails_name');
    var _submit = document.getElementById("submit");


    function validPhone() {
        if (_tel.length > 0) {
            for (var i = 0; i < _tel.length; i++) {
                _tel[i].addEventListener('focusout', function () {
                    // Remove invalid chars from the input
                    var input = this.value.replace(/[^0-9\(\)\s\-]/g, '');
                    var inputlen = input.length;
                    // Get just the numbers in the input
                    var numbers = this.value.replace(/\D/g, '');
                    var numberslen = numbers.length;
                    // Value to store the masked input
                    var newval = '';


                    // Loop through the existing numbers and apply the mask
                    for (var i = 0; i < numberslen; i++) {
                        if (i == 0) {
                            newval = "(" + numbers[i];
                        } else if (i == 3) {
                            newval += ") " + numbers[i];
                        } else if (i == 6) {
                            newval += "-" + numbers[i];
                        } else {
                            newval += numbers[i];
                        }
                    }

                    // Re-add the non-digit characters to the end of the input that the user entered and that match the mask.
                    if (inputlen >= 1 && numberslen == 0 && input[0] == "(") {
                        newval = "(";
                    } else if (inputlen >= 6 && numberslen == 3 && input[4] == ")" && input[5] == " ") {
                        newval += ") ";
                    } else if (inputlen >= 5 && numberslen == 3 && input[4] == ")") {
                        newval += ")";
                    } else if (inputlen >= 6 && numberslen == 3 && input[5] == " ") {
                        newval += " ";
                    } else if (inputlen >= 10 && numberslen == 6 && input[9] == "-") {
                        newval += "-";
                    }

                    this.value = newval.substring(0, 14);



                    if (this.hasAttribute('required') && numberslen != 0) {
                        this.classList.remove('error');
                        this.classList.add('success');
                        this.nextElementSibling.classList.remove('active');

                    } else {
                        this.classList.remove('success');
                        this.classList.add('error');
                        this.nextElementSibling.classList.add('active');
                    }

                }, false);
            }
        }
    }

    function validEmail() {
        var re = /\S+@\S+\.\S+/;

        if (_email.length > 0) {
            console.log(re.test(_email.value));
            for (var i = 0; i < _email.length; i++) {
                console.log(_email[i]);
                _email[i].addEventListener('focusout', function () {

                    if (this.hasAttribute('required') && re.test(this.value) == true) {
                        this.classList.remove('error');
                        this.classList.add('success');
                        this.nextElementSibling.classList.remove('active');

                    } else {
                        this.classList.remove('success');
                        this.classList.add('error');
                        this.nextElementSibling.classList.add('active');
                    }
                }, false);
            }
        }
    }

    function validText() {
        if (_text.length > 0) {
            for (var i = 0; i < _text.length; i++) {
                _text[i].addEventListener('focusout', function () {
                    if (this.hasAttribute('required')) {
                        if (this.value == "" || this.value <= 1) {
                            this.classList.remove('success');
                            this.classList.add('error');
                            this.nextElementSibling.classList.add('active');
                        } else {
                            this.classList.remove('error');
                            this.classList.add('success');
                            this.nextElementSibling.classList.remove('active');

                        }
                    }
                }, false);
            }
        }
    }

    function validSelect() {
        if (_select.length > 0) {
            for (var i = 0; i < _select.length; i++) {
                _select[i].addEventListener('change', function () {
                    if (this.hasAttribute('required')) {
                        if (this.value == "") {
                            this.classList.remove('success');
                            this.classList.add('error');
                            this.nextElementSibling.classList.add('active');
                        } else {
                            this.classList.remove('error');
                            this.classList.add('success');
                            this.nextElementSibling.classList.remove('active');

                        }
                    }
                }, false);
            }
        }
    }

    const _path = getUrlPath()
    const detForm = document.querySelectorAll('._detail-form,._forms form')

    // Use ValidForm to validate all personal-detail forms
    if (detForm.length > 0) {
        for (var dfi = 0; dfi < detForm.length; dfi++) {
            ValidForm(detForm[dfi], {
                errorPlacement: 'after'
            })
        }
    }

    // Minor enhancement - try to auto-format credit card expiration dates
    if (_path.indexOf("/my-account/edit-card/") === 0) {

        // console.log(_exp);
        _exp.addEventListener('input', function (e) {

            if (e.which !== 7) {
                var numChars = this.value.length;
                if (numChars === 2) {
                    var thisVal = this.value;
                    thisVal += '/';
                    this.value = thisVal;
                }
            }

        }, false);

    }


    // VALIDATION FOR CREATE ACCOUNT ON SUBSCRIBE PAGE STEP 3
    if (_path == "/subscribe/3/") {

        validText();
        validSelect();
        validEmail();
        var _pattern = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/g;
        var _pass = document.getElementById("subscriber_password");
        var _passConfirmation = document.getElementById("subscriber_password_confirm");
        if (_pass != null) {
            _pass.addEventListener('focusout', function () {

                console.log("focusout _pass", _pass.value.match(_pattern));
                if (_pass.value.match(_pattern)) {
                    this.classList.remove('error');
                    this.nextElementSibling.classList.remove('active');
                    this.classList.add('success');
                } else {
                    this.classList.remove('success');

                    this.classList.add('error');
                    this.nextElementSibling.classList.add('active');
                }
            }, false);

            _passConfirmation.addEventListener('focusout', function () {
                console.log("focusout confirmation");
                if (_pass.value != _passConfirmation.value) {
                    _pass.classList.add('error');
                    _passConfirmation.classList.add('error');
                    _passConfirmation.nextElementSibling.classList.add('active');
                } else {
                    _pass.classList.remove('error');
                    _passConfirmation.classList.remove('error');
                    _passConfirmation.nextElementSibling.classList.remove('active');
                    _pass.classList.add('success');
                    _passConfirmation.classList.add('success');
                }
            }, false);
        }
    }

    // SUBSCRIBE PAGE

    // PATRON MODAL

    var _patron = Array.from(document.querySelectorAll('.popular_packs ._patron, ._subscribe-options ._patron > a'))
    _patron.forEach(function(item) {
        // Check for an overlay
        var ovl = document.getElementById(item.dataset.index)
        if (!ovl) {
            return
        }

        // If this item has an overlay, add click handlers
        item.addEventListener('click', function(e) {
            e.preventDefault();
            ovl.classList.toggle('active')
        })
        ovl.querySelector('.close').addEventListener('click', function(e) {
            e.preventDefault();
            ovl.classList.toggle('active')
        })
    })

    // SHOWS CONTENT WITH SAME HEIGHT
    var _showWrapper = document.querySelectorAll('.subscribe-production');
    if (_showWrapper.length > 0) {
        function equalHeights(className) {
            for (var i = 0; i < _showWrapper.length; i++) {
                var findClass = _showWrapper[i].querySelectorAll(className);

                var tallest = 0;
                for (var i = 0; i < findClass.length; i++) {
                    var ele = findClass[i];
                    var eleHeight = ele.offsetHeight;
                    tallest = (eleHeight > tallest ? eleHeight : tallest); //look up ternary operator if you dont know what this is
                }
                for (var i = 0; i < findClass.length; i++) {
                    findClass[i].style.minHeight = tallest + "px";
                }
            };
        };
        equalHeights(".content");

        window.addEventListener("resize", function () {
            var _content = document.querySelectorAll('.showWrapper .content')
            for (var i = 0; i < _content.length; i++) {
                _content[i].removeAttribute('style');
            }
            equalHeights(".showWrapper .content");

        });
    }

    // READ SYNOPSIS ACCORDION
    var _accordionTitle = document.querySelectorAll('.read_more .title');
    if (_accordionTitle != null) {
        for (var i = 0; i < _accordionTitle.length; i++) {
            _accordionTitle[i].addEventListener('click', function (event) {
                this.classList.toggle("active");

                this.nextElementSibling.classList.toggle("active");
            }, false);
        }
    }
    var _accordionTitleMob = document.querySelectorAll('.read_more_mobile .title_mobile');
    if (_accordionTitleMob != null) {
        for (var i = 0; i < _accordionTitleMob.length; i++) {
            _accordionTitleMob[i].addEventListener('click', function (event) {
                this.classList.toggle("active");
                this.nextElementSibling.classList.toggle("active");
            }, false);
        }
    }


    // RENEW SUBSCRIPTION

    // DELIVERY SECTION

    var _options = document.querySelectorAll('.subscribe-delivery input[type="radio"][name="delivery_method"]');
    var _deliveryDetails = document.getElementById('deliverydetails_mail');
    if (_options.length > 0) {
        for (var i = 0; i < _options.length; i++) {
            _options[i].addEventListener('change', function () {
                console.log('changle', this.getAttribute('id'))
                var _id = this.getAttribute('id');
                if (_id == "delivery_1") {
                    _deliveryDetails.classList.add('active');
                } else {
                    _deliveryDetails.classList.remove('active');
                }
            });
        }
    }

    // NEW ADDRESS ?
    var _addressOptions = document.querySelectorAll('.followup_field input[type="radio"]');
    var _newAddress = document.getElementById('new_address');
    if (_addressOptions.length > 0) {
        for (var i = 0; i < _addressOptions.length; i++) {
            _addressOptions[i].addEventListener('change', function () {
                var _id = this.getAttribute('id');
                if (_id == "delivery__new") {
                    _newAddress.classList.add('active');
                } else {
                    _newAddress.classList.remove('active');

                }
            });
        }
    }


    // EXCHANGE TICKETS STEP 2
    var _dSel = document.querySelectorAll('.tessitura-date-selector select');

    var __id_;
    if (_dSel.length > 0) {
        for (var i = 0; i < _dSel.length; i++) {
            _dSel[i].addEventListener('change', function () {

                var selectedI = this.selectedIndex;
                __id_ = this.options[selectedI].dataset.day;

                var _eventTime = Array.prototype.slice.call(this.nextElementSibling.children);

                for (var j = 0; j < _eventTime.length; j++) {
                    console.log("CHANGE", __id_, __id_ == _eventTime[j].dataset.time);
                    if (__id_ == _eventTime[j].dataset.time) {
                        _eventTime[j].style.display = "block";

                    } else {
                        _eventTime[j].style.display = "none";
                    }

                    if (this.value.length > 0) {
                        _eventTime[0].style.display = "block";

                    } else {
                        _eventTime[0].style.display = "none";

                    }
                }
            });
        }
    }
    // ADDITIONAL TICKETS STEP 1
    var _showOptions = document.querySelectorAll('._chooseOnePerf input[type="radio"]');
    var _dateOptions = document.querySelectorAll('.tessitura-date-selector');
    var _dateSelect = document.querySelectorAll('.tessitura-date-selector select');
    var _title = document.querySelectorAll('.tessitura-date-selector .timewrapper h3');
    var _id;
    var _name;
    var __val;
    if (_showOptions.length > 0) {
        for (var i = 0; i < _showOptions.length; i++) {
            _showOptions[i].addEventListener('change', function () {
                _id = this.getAttribute('data-perf');
                for (var j = 0; j < _dateOptions.length; j++) {
                    if (_id == _dateOptions[j].getAttribute('data-perf')) {
                        _dateOptions[j].style.display = "block";
                    } else {
                        _dateOptions[j].style.display = "none";
                    }
                }
            });
        }
        for (var i = 0; i < _dateSelect.length; i++) {
            _dateSelect[i].addEventListener('change', function () {
                _name = this.getAttribute('name');
                var selectedI = this.selectedIndex;
                __val = this.options[selectedI].dataset.show;
                var _eventTime = Array.prototype.slice.call(this.nextElementSibling.children);
                for (var j = 0; j < _eventTime.length; j++) {
                    console.log(this.value.length)
                    if (__val == _eventTime[j].id) {
                        _eventTime[j].style.display = "block";

                    } else {
                        _eventTime[j].style.display = "none";
                    }

                    if (this.value.length > 0) {
                        _eventTime[0].style.display = "block";

                    } else {
                        _eventTime[0].style.display = "none";

                    }
                }

            });

        }

    }
})



/**
 * Set up the Subscribers' Additional Tickets form handling.
 *
 * Uses trkl observables and bind
 */
function setupSubsAdditional() {
    // Hard pass on non-Tess pages.
    if (!document.body.classList.contains('tessitura')) {
        return
    }

    // Only keep going if it's the Subscribers' additional tickets form
    var form = document.querySelector('.subs-additional-form');
    if (!form) {
        return
    }

    var priceDisplay = form.querySelector('.finalprice-display')
    var ticketPriceDisplay = form.querySelector('.ticketprice-display')
    var seatsDisplay = form.querySelector('.ticketnumber-display')
    // Number of Seats selector and binding
    const seats = trkl(0)
    bindValue(form.querySelector('.form-counter input[type="number"]'), seats)

    // Single-ticket price observable
    const price = trkl(0)
    price.subscribe(function (nv) {

    })

    // Selected production observable
    const production = trkl(0)
    production.subscribe(function (nv) {
        price(productionPrices.get(parseInt(nv, 10)))
    })

    // Production selector observable and binding
    const productionChoices = form.querySelectorAll('[name=show]')
    const productionPrices = new Map()

    // Map production ID to price
    productionChoices.forEach(function (choice) {
        productionPrices.set(parseInt(choice.value, 10), parseFloat(choice.getAttribute('data-price')))
    })
    bindSingleChoice(productionChoices, production)

    // Computed value for final price
    const finalPrice = trkl.computed(function () {
        var pprice = price()
        var pseats = seats()

        const fprice = (pprice * pseats) + 4
        return fprice
    })

    // Update final price display
    finalPrice.subscribe(function (val) {
        priceDisplay.innerHTML = val
        seatsDisplay.innerHTML = seats()
        ticketPriceDisplay.innerHTML = price()
    })
}

document.addEventListener('DOMContentLoaded', function() {
    if (!document.querySelector('.renew-subscription-form')) {
        return
    }

    // Fixed quantities - subtotal and fee
    var reviewContainer = document.getElementById('renew-review')
    var subtotal = parseInt(reviewContainer.dataset.total, 10)
    var fee = parseInt(reviewContainer.dataset.fees, 10)

    // Elements
    var totalDisplay = document.getElementById('price_total')
    var donationDisplay = document.getElementById('price_donation')
    // var feeDisplay = document.getElementById('price_fees')
    var donationSelect = document.querySelectorAll('.renew-subscription-form [name=donation]')
    donationSelect = Array.from(donationSelect)
    var donationOther = document.querySelector('.renew-subscription-form [name=donation_amount]')

    // Fixed value - cart total pre-donation
    var total = subtotal + fee

    // Attach event listeners
    donationSelect.forEach(function(el) {
        el.addEventListener('change', function(e) { donationHandler() })
    })
    donationOther.addEventListener('change', function(e) { donationHandler() })

    // Read selected donation value and update display
    var donationHandler = function() {
        var val = 0
        var selopt = donationSelect.filter(function(e) {
            return e.checked
        })[0]
        if (selopt.id == 'donationother') {
            val = parseInt(donationOther.value, 10)
        } else {
            val = parseInt(selopt.value, 10)
        }
        donationDisplay.innerHTML = '' + val
        totalDisplay.innerHTML = '' + (val + total)
    }
    donationHandler();
})

/**
 * Bind an Observable to a 'free' or at least singular input - e.g. a text box, number, select etc.
 * This will categorically NOT work as expected with radio buttons, radiogroups, or checkboxes.
 *
 * @param {HTMLInputElement} input
 * @param {Observable} observable
 */
function bindValue(input, observable) {
    var initial = observable();
    input.value = initial;

    observable.subscribe(function () {
        input.value = observable();
    });

    var converter = function (v) {
        return v;
    };
    if (typeof initial == 'number') {
        converter = function (n) {
            return isNaN(n = parseFloat(n)) ? 0 : n;
        };
    }

    input.addEventListener('input', function (e) {
        observable(converter(e.target.value));
    });
}

document.addEventListener('DOMContentLoaded', function () {
    var reset = document.querySelector('._reset_password')
    if (!reset) {
        return
    }
    var params = new URLSearchParams(window.location.hash.substr(1))
    var em = params.get('email')
    if (!em) {
        em = ''
    }
    var token = params.get('token')
    if (!token) {
        token = ''
    }
    reset.querySelector('#reset-email').value = em.replace(' ', '+')
    reset.querySelector('#reset-token').value = token

    var holders = reset.querySelectorAll('.reset-email-placeholder')
    holders.forEach(function (holder) {
        holder.innerHTML = em.replace(' ', '+')
    })
});

/**
 * Bind an Observable to a NodeList of radiobuttons/checkboxes
 * Records the last selected input's value only. Not an array.
 *
 * @param {NodeList} inputs
 * @param {Observable} observable
 */
function bindSingleChoice(inputs, observable) {
    var initial = observable();
    inputs.forEach(function (i) {
        if (i.value == initial) {
            i.checked = (i.value == initial);
        }
        i.addEventListener('input', function (e) {
            observable(e.target.value)
        })
    })
    observable.subscribe(function (n) {
        inputs.forEach(function (i) {
            i.checked = (i.value == n)
        })
    })
}

// SUBSCRIBE PAGE 1  - PACKAGES

/**
 * Compare two input/select elements by their value attributes
 *
 * @param {HTMLInputElement} a
 * @param {HTMLInputElement} b
 * @returns integer
 */
function input_value_cmp(a, b) {
    return a.value - b.value
}

// Given a subscription package container and a set of selected productions,
// calculate the price of a Flex subscription
function calc_flex_price(subInput, selInputs) {
    var price = 0;
    selInputs.forEach(function (s) {
        var key = 'prodPrice-' + s.value
        price += parseInt(subInput.dataset[key], 10)
    })
    return price
}

// SUBSCRIBE PAGE 1!
document.addEventListener('DOMContentLoaded', function () {

    /** Below, set up a collection of Observables to represent selections of productions
    for subscriptions made by customers. These can be subscribed to in order to have other
    effects on the page when selections change */

    // Get references to the form and subscription packages holders. If we're not on step 1, return immediately
    // since nothing here needs to run.
    var form = document.querySelector('.subscribe-form-step-1')
    if (!form) {
        return
    }
    var packages = form.querySelector('.subscribe-packages')
    var packageItems = Array.from(packages.querySelectorAll('.subscribe-subscription'))
    var packageInputs = Array.from(packages.querySelectorAll('.subscribe-subscription input'))
    var totalPrice = document.getElementById("total_price_fees")
    var submitButton = form.querySelector('button[type=submit]')

    // Get references to production and addon inputs
    if (!form) {
        return
    }

    var productionInputs = form.querySelectorAll('[name^="productions"]:not(.pseudo_addon)')
    var pseudoAddonInputs = form.querySelectorAll('.pseudo_addon')
    var addonInput = form.querySelector('[name="addon"]')

    // OBSERVABLE: "Main" productions - all those not marked as Pseudo-addons, and not true Stage II addons.
    var selectedMainProductions = trkl.from(function(observable) {
        var inputs = productionInputs
        inputs.forEach(function(input) {
            input.addEventListener('change', function() {
                observable(Array.from(form.querySelectorAll('[name^="productions"]:not(.pseudo_addon):checked')).sort(input_value_cmp))
            })
        })
    })

    // OBSERVABLE: "Pseudo-addons" - normal Friedman/S1 productions marked as pseudo-addons,
    // which can only be selected once 3 main productions are selected.
    var selectedPseudoAddons = trkl.from(function(observable) {
        var inputs = pseudoAddonInputs
        inputs.forEach(function(input) {
            input.addEventListener('change', function() {
                observable(Array.from(form.querySelectorAll('.pseudo_addon:checked')).sort(input_value_cmp))
            })
        })
        // Initial value
        observable(Array.from(form.querySelectorAll('.pseudo_addon:checked')).sort(input_value_cmp))
    })

    // OBSERVABLE: Stage II add-on option. Only a single element if selected.
    var selectedAddon = trkl.from(function(observable) {
        var input = addonInput
        if (input) {
            input.addEventListener('change', function() {
                observable(form.querySelector('[name="addon"]:checked'))
            })
        }
        // Initial value
        observable(form.querySelector('[name="addon"]:checked'))
    })

    // OBSERVABLE: All selected production form inputs, covering both main and pseudo-addons,
    // sorted by value attribute ascending.
    var selectedAllProductions = trkl.computed(function() {
        var main = selectedMainProductions()
        var pseudo = selectedPseudoAddons()
        var all = []
        if (Array.isArray(main)) {
            all = all.concat(main)
        }
        if (Array.isArray(pseudo)) {
            all = all.concat(pseudo)
        }
        return all.sort(input_value_cmp)
    })

    // OBSERVABLE: All selected productions' IDs as an array
    var selectedAllProductionsArray = trkl.computed(function() {
        return selectedAllProductions().map(function(item) {
            return item.value;
        }, '')
    })

    // OBSERVABLE: All selected productions concatenated into a string.
    var selectedAllProductionsString = trkl.computed(function() {
        return selectedAllProductions().reduce(function(output, item) {
            return '' + output + item.value;
        }, '')
    })

    // OBSERVABLE: Selected package element
    var selectedPackageEl = trkl.from(function(observable) {
        packageInputs.forEach(function(item) {
            item.addEventListener('change', function(e) {
                observable(packages.querySelector(':checked'))
            })
        })
    })

    // OBSERVABLE: Selected package ID
    var selectedPackage = trkl.computed(function() {
        var el = selectedPackageEl()
        return el ? el.value : null
    })

    // OBSERVABLE: Number of subscriptions
    var numberOfSubs = trkl.from(function(observable) {
        seatnumber.addEventListener('input', function(e) {
            observable(seatnumber.value)
        })
    })

    // OBSERVABLE: All selections
    var selectedData = trkl.computed(function() {
        var packageEl = selectedPackageEl()
        var selectedPackageName =  packageEl? packageEl.dataset.packName : null
        var selectedPackagePrice = packageEl ? parseInt(packageEl.dataset.packPrice, 10) : null
        var selectedPackageCount = packageEl ? parseInt(numberOfSubs(), 10) : null
        var selectedPackageFee = packageEl ? parseInt(packageEl.dataset.fee, 10) : null
        var subTotal = packageEl ? selectedPackageCount * selectedPackagePrice : 0
        var fullTotal = packageEl ? subTotal + selectedPackageFee : 0
        return {
            'seats': numberOfSubs(),
            'packageName': selectedPackageName,
            'packagePrice': selectedPackagePrice,
            'packageFee': selectedPackageFee,
            'subtotal': subTotal,
            'fulltotal': fullTotal,
            'display': (!!packageEl) && (numberOfSubs() > 0),
        }
    })

    // SUBSCRIBER: Check whether pseudo-addons are eligible for selection
    selectedMainProductions.subscribe(function(newval, oldval) {
        if (newval.length >= 3) {
            pseudoAddonInputs.forEach(function(item) {
                item.disabled = false
                item.classList.remove('unselectable')
                const e = new Event("change");
                item.dispatchEvent(e)
            })
        } else {
            pseudoAddonInputs.forEach(function(item) {
                item.checked = false
                item.disabled = true
                item.classList.add('unselectable')
                const e = new Event("change");
                item.dispatchEvent(e)
            })
        }
    })

    // SUBSCRIBER: Save the production selections to localStorage
    selectedAllProductionsArray.subscribe(function(newval) {
        sessionstorage_save('tsub-s1-pr', newval)
    })

    // SUBSCRIBER: Save whether Stage II addon is selected
    selectedAddon.subscribe(function(newval) {
        sessionstorage_save('tsub-s1-ad', newval)
    })

    // SUBSCRIBER: Save number of seats selected
    numberOfSubs.subscribe(function(newval) {
        sessionstorage_save('tsub-s1-ns', newval)
    })

    // SUBSCRIBER: When the production selection changes, make sure to update the UI
    selectedAllProductionsString.subscribe(function(newval) {
        var addon = selectedAddon()
        var include_addon = !!addon
        var include_addon_str = include_addon ? "1" : "0"
        var selstr = newval

        // Calculate the number of shows (+ addon) for filtering which Flex packages [if any] to show
        var flexlength = selectedAllProductions().length + (include_addon ? parseInt(addon.dataset.addoncount, 10) : 0)

        var fixed = packages.querySelectorAll('[data-subtype="Fixed"][data-prods="' + selstr + '"][data-addon="' + include_addon_str + '"]')
        var flex = packages.querySelectorAll('[data-subtype="Flex"][data-flex-min="' + flexlength + '"][data-addon="' + include_addon_str + '"]')

        // Show/hide relevant package selections (if any)
        packageInputs.forEach(function(item) {
            item.checked = false
            item.dispatchEvent(new Event('change'))
        })
        if (Array.isArray(packageItems)) {
            packageItems.forEach(function(package) {
                package.style.display = 'none'
            })
            fixed.forEach(function(package) {
                package.style.display = ''
            })
            flex.forEach(function(package) {
                var flexprice = calc_flex_price(package.querySelector('input'), selectedAllProductions())
                package.style.display = ''
                package.querySelector('.flex_price').innerHTML = '$' + flexprice
                // to add flex price to input data attr
                package.querySelector('._flexPrice_').dataset.packPrice = flexprice;
            })
        }
    }, true)

    // SUBSCRIBER: When the package selection changes
    selectedPackage.subscribe(function(newval, oldval) {
        sessionstorage_save('tsub-s1-pk', newval)
    })

    // SUBSCRIBER: When package and seat number selection changes
    // Production selection is a prerequisite for this even working,
    // so we don't explicitly check for it. Handles the total display
    // and Next button enabled/disabled status.
    selectedData.subscribe(function(newval) {
        if (newval.display) {
             // Set local storage
             localStorage.setItem("packName", newval.packageName);
             localStorage.setItem("packPrice", newval.packagePrice);
             localStorage.setItem("packQuantity", newval.seats);
             localStorage.setItem("packFee", newval.packageFee);
             localStorage.setItem("packTotal", newval.subtotal);

             totalPrice.querySelector('#quantity').innerHTML = newval.seats
             totalPrice.querySelector('#pack_name').innerHTML = newval.packageName;
             totalPrice.querySelector('#Price_').innerHTML = newval.packagePrice;
             // totalPrice.querySelector('#Price_').innerHTML = _subTot;
             totalPrice.querySelector('#fee').innerHTML = newval.packageFee;
             totalPrice.querySelector('#_totalPackPrice').innerHTML = newval.fulltotal;
             totalPrice.classList.add('active')
             submitButton.disabled = false
        } else {
            totalPrice.classList.remove('active')
            submitButton.disabled = true
        }
    })


    // We saved selected productions and package info to session storage. Restore the choices if they exist.
    restoreProductionSelections(productionInputs, pseudoAddonInputs, addonInput, packages)

    var showInfoButtons = document.querySelectorAll('._subscribe-showselect-showinfo')
    showInfoButtons.forEach(function(btn) {
        btn.addEventListener('click', function(e) {
            e.target.nextElementSibling.showModal()
        })

        btn.nextElementSibling.querySelector('button').addEventListener('click', function(e) {
            e.target.closest('dialog').close()
        })
    })

})

/**
 * Saves (almost) any value to sessionStorage, JSON serialized. Only JSON-able values can be saved.
 *
 * @param {string} key
 * @param {any} value
 * @returns void
 */
function sessionstorage_save(key, value) {
    if (typeof sessionStorage == 'undefined') {
        return
    }

    sessionStorage.setItem(key, JSON.stringify(value))
}

/**
 *  Loads a value from sessionStorage if it exists. Assumes valid JSON where there is a value.
 *
 * @param {string} key
 * @returns any
 */
function sessionstorage_load(key) {
    if (typeof sessionStorage == 'undefined') {
        return
    }

    var str = sessionStorage.getItem(key)
    if (str !== null) {
        return JSON.parse(str)
    }

    return str
}

/**
 * On page load, if packages were already selected and saved in sessionStorage, restore them.
 *
 * @param {Array} packages
 */
function restoreProductionSelections(productionInputs, pseudoAddonInputs, addonInput, packages) {
    var saved_prods = sessionstorage_load('tsub-s1-pr')
    var saved_pseudo = sessionstorage_load('tsub-s1-pa')
    var saved_addon = sessionstorage_load('tsub-s1-ad')
    const e = new Event("change");
    productionInputs.forEach(function(input) {
        if (saved_prods && saved_prods.indexOf(input.value) !== -1) {
            input.checked = true
        } else {
            input.checked = false
        }
        input.dispatchEvent(e)
    })

    if (saved_addon) {
        addonInput.checked = true
        input.dispatchEvent(new Event("change"))
    }

    var packageItems = Array.from(packages.querySelectorAll('.subscribe-subscription input'))
    var saved_package = sessionstorage_load('tsub-s1-pk')

    if (saved_package) {
        packageItems.forEach(function(item) {
            var ev = new Event('change')
            if (item.value == saved_package) {
                item.checked = true
                item.dispatchEvent(ev)
            } else {
                item.checked = false
            }
        })
    }

    var numSeats = parseInt(sessionstorage_load('tsub-s1-ns'), 10);
    var numSeatsEl = document.querySelector('[name=subscription_count]')
    if (numSeatsEl) {
        numSeatsEl.value = numSeats
        numSeatsEl.dispatchEvent(new Event('input'))
    }

}

document.addEventListener('DOMContentLoaded', function() {
    const _path = getUrlPath();
    // GETTING TOTAL PRICE DATA FROM LOCALSTORAGE FOR THE OTHER PAGES
    if (_path == "/subscribe/2/" || _path == "/subscribe/3/" || _path == "/subscribe/4/") {
        var _totalPrice = document.getElementById("total_price_fees");

        if (typeof priceUpdate !== 'undefined') {
            localStorage.setItem('packTotal', priceUpdate.packTotal);
            localStorage.setItem('packPrice', localStorage.getItem('packTotal') / localStorage.getItem('packQuantity'))
        }

        _totalPrice.querySelector('#quantity').innerHTML = localStorage.getItem("packQuantity");
        _totalPrice.querySelector('#pack_name').innerHTML = localStorage.getItem("packName");
        _totalPrice.querySelector('#Price_').innerHTML = localStorage.getItem("packPrice");
        _totalPrice.querySelector('#fee').innerHTML = localStorage.getItem("packFee");
        _totalPrice.querySelector('#_totalPackPrice').innerHTML = parseInt(localStorage.getItem("packTotal"), 10) + parseInt(localStorage.getItem("packFee"), 10);
    }

    // SUBSCRIBE PAGE 2 - ALL
    var eminput = document.getElementById('subscribe-email');
    if (eminput) {
        ValidForm(eminput, {
            errorPlacement: 'after'
        })
    }

   // SUBSCRIBE PAGE 2 - FIXED PACKAGE
   var _filter = document.querySelectorAll('.filters ul li');
   var _data_timeslot = document.querySelectorAll('.subscribed-fixed-performances-subpackage');
   if (_filter != null) {
       for (var i = 0; i < _filter.length; i++) {
           _filter[i].addEventListener('click', function (event) {
               var _day = this.dataset.day;
               var $this = this;
               for (var w = 0; w < _filter.length; w++) {
                   _filter[w].classList.remove('active');
               }
               // Need to loop data-timeslot
               for (var j = 0; j < _data_timeslot.length; j++) {
                   if (_data_timeslot[j].getAttribute('data-timeslot') === _day) {
                       _data_timeslot[j].style.display = 'block';
                   } else {
                       _data_timeslot[j].style.display = 'none';

                   }
               }

               $this.classList.add("active");




           }, false);
       }
   }

   // SUBSCRIBE PAGE 2 - FLEX PACKAGE
   var _dateSel = document.querySelectorAll('.subscribe-flex-production-performances select');

   var _id_;
   if (_dateSel.length > 0) {
       for (var i = 0; i < _dateSel.length; i++) {
           _dateSel[i].addEventListener('change', function () {
               var selectedI = this.selectedIndex;
               _id_ = this.options[selectedI].dataset.day;
               var _eventTime = Array.prototype.slice.call(this.parentNode.nextElementSibling.children);
               for (var j = 0; j < _eventTime.length; j++) {

                   if (_id_ == _eventTime[j].id) {
                       _eventTime[j].style.display = "block";
                       _eventTime[j].querySelector('input').checked = true

                   } else {
                       _eventTime[j].style.display = "none";
                   }

                   if (this.value.length > 0) {
                       _eventTime[0].style.display = "block";

                   } else {
                       _eventTime[0].style.display = "none";

                   }
               }
           });
       }
   }

   // Loop over date selection dropdowns and set up a datepicker for each of them
   Array.from(_dateSel).forEach(function(sel) {
       // Get lookup dates
       var validDates = Array.from(sel.querySelectorAll('option[data-reldate]')).map(function(s) {
           return s.dataset.reldate
       })

       // Find the earliest and latest valid date
       // Setting to noon right off the bat is a hack, but ensures we have the right day.
       // Javascript dates are horrible.
       var firstDate = new Date(validDates[0] + ' 12:00:00')
       firstDate.setHours(12, 0)
       var lastDate = new Date(validDates[validDates.length-1] + ' 12:00:00')
       lastDate.setHours(12,0)
       if (sel.classList.contains('fulldateselector')) {
           // Create an input to act as our datepicker
           var input = document.createElement('input')
           input.classList.add('pikaday')
           input.placeholder = "Choose date"
           input.addEventListener('change', function(event) {
               // console.log(pick.toString('YYYY-MM-DD'))
               var selectedDate = sel.querySelector('[data-reldate="' + pick.toString('YYYY-MM-DD') + '"]')
               if (selectedDate) {
                   sel.value = selectedDate.value
                   sel.dispatchEvent(new Event('change'))
               }
           })
           // Set up a Pikaday instance on the new input
           var pick = new Pikaday({
               field: input,
               trigger: sel.parentNode,
               format: 'D MMM YYYY',
               minDate: firstDate,
               maxDate: lastDate,
               disableDayFn: function(date) {
                   var d = moment(date).format('YYYY-MM-DD')
                   return validDates.indexOf(d) === -1
               }
           })
           // Set the picker's month and year so users don't have to scroll so far
           pick.gotoYear(firstDate.getFullYear())
           pick.gotoMonth(firstDate.getMonth())

           // Insert the datepicker input and hide the select box
           sel.parentNode.insertBefore(input, sel)
           sel.parentNode.classList.add('pikaday')
           sel.style.display = "none"
       }
   })
});
(function ($) {
    document.addEventListener('DOMContentLoaded', function () {
        const _path = getUrlPath();

        if (_path != "/subscribe/4/") {
            return
        }

        var donationupdate = function () {
            var _donsel = document.querySelector('._donationform input[type=radio]:checked')
            var _newtotal = 0
            var _newdonation = 0
            if (!_donsel) {
                return
            }
            if (_donsel.id == 'donationstandard') {
                _newdonation = parseInt(_donsel.value, 10)
                _newtotal = _storedTotal + _newdonation
                _totalPrice.querySelector('#_totalPackPrice').innerHTML = _newtotal
                _donationDisplay.innerHTML = parseInt(_donsel.value, 10)
                _globalpricetotal.innerHTML = '$' + _newtotal
                _globalDonationTotal.innerHTML = '$' + _newdonation
            }
            if (_donsel.id == 'donationother') {
                _newdonation = parseInt(_donationOtherAmt.value, 10)
                if (isNaN(_newdonation)) {
                    _newdonation = 0
                }
                _donationOtherAmt.value = _newdonation
                _newtotal = _storedTotal + _newdonation
                _totalPrice.querySelector('#_totalPackPrice').innerHTML = _newtotal
                _donationDisplay.innerHTML = _newdonation
                _globalpricetotal.innerHTML = '$' + _newtotal
                _globalDonationTotal.innerHTML = '$' + _newdonation
            }
            if (_donsel.id == 'donationnone') {
                _newdonation = 0
                _newtotal = _storedTotal
                _totalPrice.querySelector('#_totalPackPrice').innerHTML = _newtotal
                _donationDisplay.innerHTML = '0'
                _globalpricetotal.innerHTML = '$' + _newtotal
                _globalDonationTotal.innerHTML = '$' + _newdonation
            }

        }

        var _totalPrice = document.getElementById("total_price_fees");
        var _storedTotal = parseInt(localStorage.getItem("packTotal"), 10) + parseInt(localStorage.getItem("packFee"), 10)
        // var _donsel = _donationform.querySelector('[name=donation]:checked')
        var _donationDisplay = _totalPrice.querySelector('.donation')
        _donationDisplay.parentNode.removeAttribute('style')
        var _donationOtherAmt = document.querySelector('._donationform input[name=donation_amount]')
        var _globalpricetotal = document.getElementById('price_total')
        var _globalDonationTotal = document.getElementById('price_donation')
        Array.from(document.querySelectorAll('._donationform input')).forEach(function (el) {
            el.addEventListener('change', donationupdate)
        })

        donationupdate()

    })
})(jQuery);
/**
 * When Caldera Forms are initialised, make sure that any Tessitura-integrated
 * fields have their correct data in place.
 *
 * This includes production selectors, date/time selectors associated with
 * production selectors, customer name/address/email etc.
 */
;(function($) {
    var cfdata = null

    $(document).on('cf.form.init', function (event, data) {

        /**
         The object in the variable data has the following keys:

            //idAttr - The form's ID attribute
            idAttr: form_id,
            //formId - The forms's ID
            formId: formId,
            //state -the form's state object
            state: state,
            //fieldIds the ids of all field
            fieldIds: CFFIELD_CONFIG[instance].fields.hasOwnProperty('ids') ? CFFIELD_CONFIG[instance].fields.ids : []
        */

        var state = data.state

        // console.log(CFFIELD_CONFIG, data)

        // Form instance on page (in case there are several of the same)
        var instance = data.$form.data('instance')
        var form = CFFIELD_CONFIG[instance]

        // Find datepickers
        var pickers = form.fields.inputs.filter(function(field) { return field.type === 'aka_pikaday' })
        var proddatepickers = []
        // For each of them, check whether they're followed by a _time_sel.
        // If so, do some more setup and subscribe to change events to affect time selectors
        pickers.forEach(function(picker) {
            var elem = $('#' +picker.id + '-wrap')
            var input = $('#'+picker.id)
            var nextelem = elem.next('._time_sel')
            // No associated time-picker? Skip it.
            if (nextelem.length === 0) {
                return true // same as Continue in a foreach
            }

            // There IS a 'timepicker', so get the values we'll want to selectively
            // enable or disable.
            var matinee_opt = $("[value='Matinee']", nextelem)
            var evening_opt = $("[value='Evening']", nextelem)
            var time_field = $("[data-field='" + nextelem.data('field-wrapper') + "']", nextelem)

            // On selection of a date, modify the following timepicker
            // so that the selected date's timeslots (matinee/evening)
            // are enabled or disabled. Clear the timeslot picker as well,
            // since the value may be invalid and should be selected again
            // anyway
            state.events().subscribe(picker.id, function(fieldId, value) {
                if (window.currentSelected && value) {
                    var fdate = moment(value, 'D MMM YYYY').format('YYYY-MM-DD')
                    var dateopts = DEVO_DATES[window.currentSelected].dates[fdate]
                    state.mutateState(time_field.attr('id'), '')
                    time_field.val('')
                    if (dateopts) {
                        matinee_opt.attr('disabled', !dateopts.matinee)
                        evening_opt.attr('disabled', !dateopts.evening)
                    } else {
                        matinee_opt.attr('disabled', true)
                        matinee_opt.attr('disabled', true)
                    }
                }
            })

            // Create the datepicker
            var pikaday = input.data('pikaday')
            proddatepickers.push(pikaday)
        })

        window.akaPikadayDisable = function(date) {
            date.setHours(12, 0, 0) // Force to noon in whichever timezone. Horrible hedge, but works for now.
            var date_fmt = moment(date).format('YYYY-MM-DD') // Format the date like the
            if (DEVO_DATES.hasOwnProperty(window.currentSelected)) {
                return ! DEVO_DATES[window.currentSelected].dates.hasOwnProperty(date_fmt)
            }
            return false
        }

        // Find production selectors
        var prodsels = form.fields.inputs.filter(function(field) { return field.type === 'dropdown' })
        prodsels.forEach(function(prodsel) {
            var elem = $('#' +prodsel.id + '-wrap')
            var input = $('#'+prodsel.id)
            if (elem.hasClass('_select_prod')) {
                state.events().subscribe(prodsel.id, function(id, value) {
                    window.currentSelected = value
                    // console.log('Production change', value, DEVO_DATES.hasOwnProperty(value), DEVO_DATES[value])
                    if (DEVO_DATES.hasOwnProperty(value)) {
                        var dates = DEVO_DATES[value]
                        var psdate = new Date(dates.first_date + ' 12:00:00')
                        var pedate = new Date(dates.last_date + ' 12:00:00')
                        proddatepickers.forEach(function(p) {
                                p.setDate(null)
                                p.gotoYear(psdate.getFullYear())
                                p.gotoMonth(psdate.getMonth())
                                p.setMinDate(psdate)
                                p.setMaxDate(pedate)
                            })
                    }
                })
            }
        })


        /**
         * FORM SPECIFIC options - Patron Additional Tickets form.
         * Calculate total cost of additional tickets based on form values.
         *
         *
         */
        if (data.formId == 'CF5e3bf17c55aff' || data.formId == 'CF5f037283abba6') {
            console.log(form);
            // Initialise the calculation(s)
            var patFieldIds = [
                'fld_7014932', // Prod sel
                'fld_7173347', // Date sel 1
                'fld_6739367', // Time sel 1
                'fld_1692977', // Date sel 2
                'fld_6347817', // Time sel 2
                'fld_9682294', // Type sel
                'fld_2992354', // Number of tickets
                'fld_8857036', // Total field
            ]
            var theFormFields = form.fields.inputs.filter(function(inp) {
                return patFieldIds.indexOf(inp.fieldId) >= 0
            })
            var stateFieldIds = theFormFields.map(function(inp) {
                return inp.id
            })
            var totalField = document.getElementById(stateFieldIds[7])
            totalField.setAttribute('readonly', 'readonly')
            var patTotalId = 'fld_8857036'
            theFormFields.forEach(function(fid) {
                // Attach change event to the fields that we need to.
                state.events().subscribe(fid.id, patronAdditionalCalc)
            })
        }
        function patronAdditionalCalc() {
            // Calculate total price if at all possible
            var production = state.getState(stateFieldIds[0])
            var date1 = state.getState(stateFieldIds[1])
            var time1 = state.getState(stateFieldIds[2])
            var type = state.getState(stateFieldIds[5])
            var numseats = state.getState(stateFieldIds[6])

            // If not all the require fields are filled, just don't even try and return blank
            if (!(production && date1 && time1 && type && numseats)) {
                return ''
            }

            // If we got all the values, check the price(s), calculate and set.
            var prices = window.DEVO_PRICES[production]
            var price = type == 'Discount Seats' ? prices.discount_price : prices.patron_price
            state.mutateState(stateFieldIds[7], numseats * price)
            totalField.value = '$' + (numseats * price)
        }

        return

        state.events().subscribe('fld_7289892_1', function (fieldId, value) {
            console.log('test_field changed to:', value)
            console.log('fieldId', fieldId)
            return;
            //Change the value of another field to this field's new value plus 7 percent
            //IMPORTANT- Change "fld_7788423_1" to the ID of the field you want to set
            var newValue = value * 1.07;
            //change state
            state.mutateState('fld_7788423_1', newValue);
            //update field -- NOTE: This will not be necessary in future versions of Caldera Forms
            jQuery('#fld_7788423_1').val(newValue);
        });

    });
})(jQuery)

